(function () {
  let lastVariant = new URLSearchParams(window.location.search).get('variant');

  document.addEventListener('change', function (e) {
    if (!e.target.name || !e.target.name.includes('options')) return;

    setTimeout(() => {
      const newVariant = new URLSearchParams(window.location.search).get('variant');

      if (newVariant && newVariant !== lastVariant) {
        lastVariant = newVariant;
        window.location.reload();
      }
    }, 200);
  });
})();



(function () {
  let lastVariant = new URLSearchParams(window.location.search).get('variant');

  const observer = new MutationObserver(function () {
    const currentVariant = new URLSearchParams(window.location.search).get('variant');

    if (currentVariant && currentVariant !== lastVariant) {
      lastVariant = currentVariant;
      window.location.reload();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();